import React from 'react';

const colorMap = {
  brand:  'bg-brand-500/15  text-brand-400  border-brand-500/25',
  orange: 'bg-amber-500/15  text-amber-400  border-amber-500/25',
  green:  'bg-emerald-500/15 text-emerald-400 border-emerald-500/25',
  blue:   'bg-sky-500/15    text-sky-400    border-sky-500/25',
  purple: 'bg-violet-500/15 text-violet-400 border-violet-500/25',
  red:    'bg-rose-500/15   text-rose-400   border-rose-500/25',
  gray:   'bg-surface-500   text-surface-200 border-surface-400',
};

const Badge = ({ label, color = 'gray', dot = true, className = '' }) => (
  <span
    className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-dm font-medium border ${colorMap[color] ?? colorMap.gray} ${className}`}
  >
    {dot && (
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ background: 'currentColor' }}
      />
    )}
    {label}
  </span>
);

export default Badge;
